import { render, staticRenderFns } from "./adstxt.vue?vue&type=template&id=8f11320e&scoped=true&"
import script from "./adstxt.vue?vue&type=script&lang=js&"
export * from "./adstxt.vue?vue&type=script&lang=js&"
import style0 from "./adstxt.vue?vue&type=style&index=0&id=8f11320e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f11320e",
  null
  
)

export default component.exports